<template>
    <div class="tw-px-4">
        <div class="tw-grid tw-grid-cols-12 tw-gap-4">
            <div class="lg:tw-col-span-3 tw-col-span-12">
                <div class="tw-h-[250px]x tw-pb-8 tw-p-4 tw-bg-white tw-border tw-border-solid tw-border-primary-200 tw-rounded-lg">
                    <div class="tw-flex tw-justify-end">
                        <router-link :to="{name: 'shared.my-account'}" class="tw-text-gray-500 tw-text-sm tw-font-semibold">Edit</router-link>
                    </div>

                    <div class="tw-flex tw-items-center tw-justify-center tw-mt-4 tw-flex-col">
                        <div class="tw-w-[100px] tw-h-[100px] tw-rounded-full tw-bg-primary-800 tw-flex tw-items-center tw-justify-center tw-relative">
                            <template v-if="$user.profile_image">
                                <img :src="$user.profile_image" class="tw-w-full tw-h-full tw-object-cover tw-rounded-full tw-bg-white" />
                            </template>
                            <template v-else>
                                <icon icon="solar:user-circle-linear" class="tw-text-primary-50 tw-text-6xl tw-font-semibold " />
                            </template>

                            <div class="tw-absolute tw-bottom-1 tw-right-1 tw-w-[20px] tw-h-[20px] tw-rounded-full tw-bg-primary-500 tw-flex tw-items-center tw-justify-center tw-border-4 tw-border-solid tw-border-white"></div>
                        </div>

                        <h1 class="tw-text-primary-950 tw-text-lg md:tw-text-2xl tw-font-semibold tw-mt-2 tw-text-center">{{ $user.name }}</h1>
                        <h2 class="tw-text-primary-950 tw-text-sm tw-font-semibold tw-mt-1 tw-text-center tw-capitalize"> {{ $user.role }}</h2>
                    </div>



                </div>

                <div class="tw-mt-4">
                    <h1 class="tw-text-primary-950 tw-text-xl tw-font-semibold">My Companies</h1>
                </div>

                <!-- Companies found -->
                <div v-if="myCompaniesFetched && myCompanies.length > 0">
                    <MyCompanyCard v-for="company in myCompanies" :key="company.id" :company="company" />
                </div>

                <!-- No companies found -->
                <div v-else-if="myCompaniesFetched && myCompanies.length === 0">
                    <div class="tw-bg-white tw-border tw-border-solid tw-border-primary-200 tw-rounded-lg tw-mt-4 tw-p-6 tw-text-center">
                        <icon icon="solar:buildings-3-linear" class="tw-text-gray-400 tw-text-5xl tw-mb-3 tw-mx-auto" />
                        <p class="tw-text-gray-500 tw-text-lg tw-font-medium tw-mb-1">No Companies Found</p>
                        <p class="tw-text-gray-400 tw-text-sm">You don't have any companies associated with your account yet.</p>
                    </div>
                </div>

                <!-- Loading state -->
                <div v-else>
                    <div v-for="i in 1" :key="i" class="tw-bg-white tw-border tw-border-solid tw-border-primary-200 tw-rounded-lg tw-mt-4 tw-flex tw-gap-4 tw-p-4">
                        <!-- Logo placeholder -->
                        <div class="tw-min-w-[60px] tw-min-h-[60px] tw-bg-gray-200 tw-animate-pulse tw-rounded-lg tw-flex-shrink-0"></div>

                        <!-- Text content placeholder -->
                        <div class="tw-flex tw-flex-col tw-justify-center tw-gap-1 tw-flex-1">
                            <!-- Company name placeholder -->
                            <div class="tw-h-5 tw-bg-gray-200 tw-animate-pulse tw-rounded tw-max-w-[200px]"></div>
                            <!-- Role placeholder -->
                            <div class="tw-h-4 tw-bg-gray-200 tw-animate-pulse tw-rounded tw-w-20"></div>
                        </div>

                        <!-- Action button placeholder -->
                        <div class="tw-flex tw-items-center tw-justify-center">
                            <div class="tw-w-6 tw-h-6 tw-bg-gray-200 tw-animate-pulse tw-rounded"></div>
                        </div>
                    </div>
                </div>

            </div>

            <div class="lg:tw-col-span-6 tw-col-span-12">
                <!-- <div class="tw-aspect-[34/11] tw-rounded-lg tw-overflow-hidden tw-pointer-events-none tw-bg-primary-800">
                    <iframe
                        width="100%"
                        height="100%"
                        src="https://www.youtube.com/embed/5ngD7XZGN74?si=Gq9FMDyU_OEMPBzI&autoplay=1&mute=1&controls=0&loop=1&playlist=5ngD7XZGN74&rel=0&modestbranding=1&showinfo=0"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin"
                        allowfullscreen
                        class="tw-rounded-lg">
                    </iframe>
                </div> -->

                <!-- <div class="">
                    <img :src="$frontend('assets/images/banner-visual-scaled.jpg')" alt="Dashboard Background" class="tw-w-full tw-object-cover tw-rounded-lg" />
                </div> -->
                <div class="">
                    <video
                        :src="$frontend('assets/images/banner-1.mp4')"
                        autoplay
                        muted
                        loop
                        playsinline
                        class="tw-w-full tw-object-cover tw-rounded-lg"
                    ></video>
                </div>

                <div class="tw-grid tw-grid-cols-2 tw-gap-4 tw-mt-4">
                    <template v-for="link in navigationLinks" :key="link.key">
                        <router-link
                            v-if="!isExternalLink(link.route)"
                            :to="link.route"
                            :class="[
                                'md:tw-h-[100px] tw-h-[80px] tw-rounded-lg tw-flex tw-items-center tw-justify-center tw-relative tw-overflow-hidden hover:tw-opacity-90 tw-transition-opacity',
                                getNavigationStyles(link.key).bg,
                                shouldShowIcon(link.key) ? 'tw-gap-2' : ''
                            ]">
                            <div class="tw-absolute tw-inset-0 tw-bg-cover tw-bg-center tw-opacity-75 tw-hidden" style="background-image: url('https://v1.thefoodeshow.com/assets/front_office/imgs/public/image-57@2x-a10cd7883c643a8cb2b49e680cc615e8.png');"></div>
                            <icon
                                v-if="shouldShowIcon(link.key) && link.icon"
                                :icon="link.icon"
                                :class="[
                                    'tw-text-3xl tw-font-semibold tw-z-10',
                                    getNavigationStyles(link.key).text
                                ]"
                            />
                            <p :class="[
                                'tw-text-lg md:tw-text-2xl tw-font-semibold tw-z-10',
                                getNavigationStyles(link.key).text
                            ]">
                                {{ getDisplayName(link) }}
                            </p>
                        </router-link>
                        <a
                            v-else
                            :href="link.route"
                            :target="getTarget(link)"
                            :rel="getTarget(link) === '_blank' ? 'noopener noreferrer' : null"
                            :class="[
                                'md:tw-h-[100px] tw-h-[80px] tw-rounded-lg tw-flex tw-items-center tw-justify-center tw-relative tw-overflow-hidden hover:tw-opacity-90 tw-transition-opacity',
                                getNavigationStyles(link.key).bg,
                                shouldShowIcon(link.key) ? 'tw-gap-2' : ''
                            ]">
                            <div class="tw-absolute tw-inset-0 tw-bg-cover tw-bg-center tw-opacity-75 tw-hidden" style="background-image: url('https://v1.thefoodeshow.com/assets/front_office/imgs/public/image-57@2x-a10cd7883c643a8cb2b49e680cc615e8.png');"></div>
                            <icon
                                v-if="shouldShowIcon(link.key) && link.icon"
                                :icon="link.icon"
                                :class="[
                                    'tw-text-3xl tw-font-semibold tw-z-10',
                                    getNavigationStyles(link.key).text
                                ]"
                            />
                            <p :class="[
                                'tw-text-lg md:tw-text-2xl tw-font-semibold tw-z-10',
                                getNavigationStyles(link.key).text
                            ]">
                                {{ getDisplayName(link) }}
                            </p>
                        </a>
                    </template>
                </div>

                <SponsorBand class="tw-mt-6" />

            </div>

            <div class="lg:tw-col-span-3 tw-col-span-12 tw-h-fit tw-bg-primary-600 tw-rounded-lg tw-border tw-border-solid tw-border-primary-200">
                <img :src="$frontend('assets/images/banner-2.png')"  class="tw-w-full tw-object-contain tw-rounded-lg" />
            </div>

        </div>


    </div>
  </template>

  <script setup>
    import { computed } from 'vue';
    import { useI18n } from 'vue-i18n';
    import MyCompanyCard from '@/components/dashboard/exhibitor/MyCompanyCard';
    import { useStateStore } from '@/stores/app/state';
    import SponsorBand from '@/components/dashboard/SponsorBand.vue';
    import { useAuthStore } from '@/stores/auth';
    import { getFilteredNavigationLinks, isExternalLink, getNavigationDisplayName, getNavigationTarget } from '@/config/navigation';

    const stateStore = useStateStore();
    const authStore = useAuthStore();
    const { t } = useI18n();

    const myCompanies = computed(() => stateStore.myCompanies.data);
    const myCompaniesFetched = computed(() => stateStore.myCompanies.fetched);

    // Get filtered navigation links based on user role, excluding 'home' since we're already on dashboard
    const navigationLinks = computed(() => {
        return getFilteredNavigationLinks(authStore.user?.role).filter(link => link.key !== 'home');
    });

    // Get display name for navigation link
    const getDisplayName = (link) => {
        return getNavigationDisplayName(link, t);
    };

    // Get target attribute for navigation link
    const getTarget = (link) => {
        return getNavigationTarget(link);
    };

    // Styling mapping function for navigation items
    const getNavigationStyles = (key) => {
        const styleMap = {
            'my-eshow': { bg: 'tw-bg-primary-200', text: 'tw-text-primary-950' },
            'companies': { bg: 'tw-bg-primary-200', text: 'tw-text-primary-950' },
            'vib-buyers': { bg: 'tw-bg-primary-500', text: 'tw-text-primary-50' },
            'community': { bg: 'tw-bg-primary-500', text: 'tw-text-primary-50' },
            'speakers': { bg: 'tw-bg-primary-500', text: 'tw-text-primary-50' },
            'agenda': { bg: 'tw-bg-primary-500', text: 'tw-text-primary-50' },
            'products': { bg: 'tw-bg-primary-900', text: 'tw-text-primary-50' },
            'services': { bg: 'tw-bg-primary-900', text: 'tw-text-primary-50' },
            'foodshow-on-demand': { bg: 'tw-bg-orange-200', text: 'tw-text-primary-800' },
            'help-desk': { bg: 'tw-bg-sky-600', text: 'tw-text-primary-50' }
        };
        return styleMap[key] || { bg: 'tw-bg-primary-500', text: 'tw-text-primary-50' };
    };

    // Check if navigation item should show icon
    const shouldShowIcon = (key) => {
        return ['foodshow-on-demand', 'help-desk'].includes(key);
    };
  </script>

  <style></style>
